module.exports = __webpack_public_path__ + "static/img/img_11.9493c97.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/code/img_11.jpg
// module id = 63
// module chunks = 20